/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NextAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NextAction({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Actions/NextAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imageCaptureQuestionIsValidValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'isValid',
})
let imageCaptureSelectedIsCompleteValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureSelected',
path: 'isComplete',
})
let aggregateData = fromHelpers.shouldDisplay(imageCaptureQuestionIsValidValueData, imageCaptureSelectedIsCompleteValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}